import { render, staticRenderFns } from "./Course4.vue?vue&type=template&id=6eb31e33&scoped=true"
import script from "./Course4.vue?vue&type=script&lang=ts"
export * from "./Course4.vue?vue&type=script&lang=ts"
import style0 from "@/assets/css/course.css?vue&type=style&index=0&id=6eb31e33&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb31e33",
  null
  
)

export default component.exports